import actionTypes from '../../action-types'

export default (customerId, payload) => ({
  type: actionTypes.CUSTOMERS.UPDATE_METADATA_LOCATIONS,
  payload,
  meta: {
    customerId,
  },
})
